import { useActiveOrderManager } from './useActiveOrderManager';

export function useVariantProductPrice() {
    const activeOrderManager = useActiveOrderManager();

    return {
        getFinalPrice({ productId, productPrice }: { productId: number; productPrice: number }) {
            return activeOrderManager.calculateProductDiscount(productId, productPrice);
        },
    };
}
